export default __webpack_public_path__ + "static/10-b47c8ce7f9a4810e48a3dfacefc5d17c.webp";